import { Injectable } from '@angular/core';

import { RootState } from '@next/core-lib/app';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';

import * as actions from '../store/actions/tail-biting.actions';

@Injectable({
  providedIn: 'root',
})
export class TailBitingGuard {
  constructor(private readonly store: Store<RootState>) {}

  canActivate(): Observable<boolean> {
    this.store.dispatch(actions.getTailBitingsRequest());
    return of(true);
  }
}
